<template>
  <v-container class=" fill-height mt-2 align-start">
    <v-row class="fill-height">
      <v-col cols="6" class="pa-0 ma-0">
        <v-row>
          <v-col cols="12" class="pa-0 ma-0">
            <claim-actions-panel :claim="activeClaim" :filter="currentFilter" @onCommand="processCommand"/>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <ui-nav-list :theme="'light'" :list="filtersTree" :on-item-click="callFn"></ui-nav-list>
          </v-col>
          <v-divider vertical/>
          <v-col cols="6">
            <claims-list :highlight="true" @input="setActiveClaim"></claims-list>
          </v-col>
          <v-divider vertical/>
        </v-row>
      </v-col>
      <v-col cols="6" class="pt-0">
        <v-system-bar color="primary" class="white--text" dark>
          Переписка по запросу <span class="yellow--text ml-2"> {{activeClaim.DOC_NUM}} {{activeClaim.DOC_TYPE }}</span>
        </v-system-bar>
        <claim-comments-list :claim="activeClaim" ></claim-comments-list>
        <claim-files-list :claim="activeClaim" />
      </v-col>
    </v-row>
    <claim-action-dialog v-model="showClaimAction" :claim="activeClaim"/>
  </v-container>
</template>

<script>
import {
  CLM_CREATE_CLAIM, CLM_DATA_LONGPOLL,
  CLM_GET_CLAIM_STATUS_LIST,
  CLM_GET_CLAIM_TYPES_LIST, CLM_POST_CLAIM,
  CLM_SET_CLAIMS_FILTER,
  CLM_SET_CURRENT_CLAIM
} from '@/store/actions/claims'
import UiNavList from '@/components/common/ui/lists/navMultilevel/uiNavList'
import ClaimsList from '@/components/modules/claims/forms/claimsList'
import ClaimCommentsList from '@/components/modules/claims/forms/claimCommentsList'
import ClaimFilesList from '@/components/modules/claims/forms/claimFileList'
import ClaimActionsPanel from '@/components/modules/claims/panels/claimActionsPanel'
import { UI_SNACKBAR } from '@/store/actions/ui'
import ClaimActionDialog from '@/components/modules/claims/dialogs/claimActionDialog'

export default {
  name: 'claimsIndexView',
  components: { ClaimActionDialog, ClaimActionsPanel, ClaimFilesList, ClaimCommentsList, ClaimsList, UiNavList },
  data () {
    return {
      states: [],
      types: [],
      filtersTree: [],
      activeItem: {},
      showClaimAction: false
    }
  },
  computed: {
    currentFilter: {
      get: function () {
        return {
          DS_ID: this.activeItem.DS_ID || null,
          DT_ID: this.activeItem.DT_ID || null
        }
      }
    },
    activeClaim: {
      get: function () {
        return this.$store.getters.getCurrentClaim
      }
    },
    newItemsCount: {
      get: function () {
        const sn = this.$store.getters.getClaimsLPData
        return sn.length
      }
    }
  },
  watch: {
    activeItem () {
      this.$store.dispatch(CLM_SET_CLAIMS_FILTER, this.currentFilter)
    },
    newItemsCount () {
      this.resetBadges()
    }
  },
  methods: {
    getTypeNewsCount (typeID) {
      const sn = this.$store.getters.getClaimsLPData.filter(itm => itm.DT_ID === typeID)
      return sn.length
    },
    getTypeStateNewsCount (typeID, stateID) {
      const sn = this.$store.getters.getClaimsLPData.filter(itm => itm.DT_ID === typeID && itm.DS_ID === stateID)
      return sn.length
    },
    resetBadges () {
      this.filtersTree[0].badge = this.newItemsCount
      this.filtersTree[0].children.forEach(type => {
        type.badge = this.getTypeNewsCount(type.DT_ID)
        type.children.forEach((state) => {
          state.badge = this.getTypeStateNewsCount(type.DT_ID, state.DS_ID)
        }, this)
      }, this)
    },
    getFiltersTree () {
      console.log('Building filters tree started with types ', this.types, ' and states ', this.states)
      const ret = [
        {
          node_id: 'root_node',
          label: 'Все запросы',
          DT_ID: '-5',
          DS_ID: '-5',
          open: true,
          active: true,
          badge: this.newItemsCount,
          children: []
        }
      ]
      this.types.forEach(type => {
        const itm = {
          node_id: 'dt' + type.DT_ID + 'ds-5',
          label: type.DT_NAME,
          DT_ID: type.DT_ID,
          DS_ID: '-5',
          open: false,
          active: false,
          badge: this.getTypeNewsCount(type.DT_ID),
          children: []
        }
        this.states.forEach((state) => {
          const child = {
            node_id: 'dt' + type.DT_ID + 'ds' + state.DS_ID,
            label: state.DS_NAME,
            DT_ID: type.DT_ID,
            DS_ID: state.DS_ID,
            open: false,
            active: false,
            badge: this.getTypeStateNewsCount(type.DT_ID, state.DS_ID)
          }
          itm.children.push(child)
        }, this)
        ret[0].children.push(itm)
      }, this)
      console.log('Building filters tree finished with result ', ret)
      this.filtersTree.splice(0, 1, ...ret)
      this.activeItem = this.filtersTree.length ? this.filtersTree[0] : {}
    },
    initData () {
      this.$store.dispatch(CLM_GET_CLAIM_STATUS_LIST)
        .then(res => {
          this.states = res.filter(item => item.DS_ID !== '-5')
          this.$store.dispatch(CLM_GET_CLAIM_TYPES_LIST)
            .then(res => {
              this.types = res.filter(item => item.DT_ID !== '-5')
              this.getFiltersTree()
            })
            .catch((err) => {
              console.log('Ошибка получения списка типов запросов: ', err)
            })
        })
        .catch((err) => {
          console.log('Ошибка получения списка состояний запросов: ', err)
        })
    },
    callFn (item) {
      item.open = !item.open
      this.activeItem = item
    },
    setActiveClaim (claim) {
      console.log('claimsIndex setting active claim ', claim)
      this.$store.dispatch(CLM_DATA_LONGPOLL)
        .then(() => {
          this.resetBadges()
        })
    },
    processCommand (command) {
      console.log('onProcessCommand event ', command)
      switch (command) {
        case 'addClaim':
          this.addClaim()
          break
        case 'changeStatus':
          this.showClaimAction = true
          break
        case 'deleteClaim':
          this.$store.dispatch(CLM_POST_CLAIM, { PTC: 'state', DOC_ID: this.activeClaim.DOC_ID, DS_ID: this.activeClaim.DS_ID, SIGNAL_ID: '-3' })
            .catch((err) => {
              this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка удаления заявки' + err })
            })
          break
        default:
          console.log('Unknown command: ', command)
      }
    },
    addClaim () {
      const data = {
        description: '',
        DT_ID: this.currentFilter.DT_ID
      }
      const self = this
      this.$store.dispatch(CLM_CREATE_CLAIM, data)
        .then(resp => {
          this.$store.dispatch(CLM_SET_CURRENT_CLAIM, resp)
        })
        .catch(err => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка создания заявки' + err })
        })
        .finally(() => {
        })
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style scoped>

</style>
